import React, {Component} from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl,
    InputGroup,
    Row,
    Col
}                         from "react-bootstrap";
import Dropzone           from "react-dropzone";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";
import moment             from "moment";

import { IS_VALID }       from "utils";

import Loader             from "../../Loader";
import ic_add_image       from "../../../assets/image/ic_add_image.svg";

class Create extends Component {
    constructor (props) {
        super(props);

        this.dropzoneRef;
    }


    render () {
        let {
            isLoadingAction,

            selectedData,

            image,
            bannerImage,
            title,
            descriptions,
            earningPeriodStartDate,
            earningPeriodEndDate,
            earningPeriod,
            campaignStartDate,
            campaignEndDate,
            evoucherSortColumn,
            evoucherSortColumnOptions,
            evoucherSorting,
            evoucherSortingOptions,

            availabilityStartTime,
            availabilityEndTime,

            actions,

            loadOptions
        } = this.props;

        let requiredSpan = <span style={{ color: "red" }}>*</span>;

        let imageSrc = ic_add_image,
            imageStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                width: '100px',
                height: '100%'
            },
            dropZoneStyle = {
                display: "inline-block",
                verticalAlign: "top"
            },
            isHideX = {
                display: 'none'
            };

        if (IS_VALID(image)) {
            imageSrc = image.preview;
            imageStyle = {
              ...imageStyle,
              width: '',
              maxWidth: '100%',
              maxHeight: '100%'
            };
            dropZoneStyle = {
              verticalAlign: "middle"
            };
            isHideX = {};
        }

        let banner_imageSrc = ic_add_image,
            banner_imageStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                width: '100px',
                height: '100%'
            },
            banner_dropZoneStyle = {
                display: "inline-block",
                verticalAlign: "top"
            },
            banner_isHideX = {
                display: 'none'
            };

        if (IS_VALID(bannerImage)) {
            banner_imageSrc = bannerImage.preview;
            banner_imageStyle = {
            ...banner_imageStyle,
            width: '',
            maxWidth: '100%',
            maxHeight: '100%'
            };
            banner_dropZoneStyle = {
            verticalAlign: "middle"
            };
            banner_isHideX = {};
        }
        
        let isEVoucherPublished = (
            IS_VALID(selectedData) &&
            IS_VALID(selectedData.get("status")) &&
            (
                selectedData.get("status") === "PUBLISH" ||
                selectedData.get("status") === "EXPIRED"
            ) &&
            (
                IS_VALID(selectedData.get("campaignStartDate")) &&
                moment(selectedData.get("campaignStartDate")).isSameOrBefore(moment())
            )
        );

        let totalCampaignDays = 0;

        if (
            IS_VALID(campaignStartDate) &&
            moment(campaignStartDate).isValid() &&
            IS_VALID(campaignEndDate) &&
            moment(campaignEndDate).isValid()
        ) {
            let totalDays = moment(moment(campaignEndDate).startOf("day")).diff(moment(campaignStartDate).startOf("day"), "days") + 1;

            if (totalDays >= 0) {
              totalCampaignDays = totalDays;
            }
        }

        return (
            <form>
                <Loader loading={isLoadingAction}/>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Title {requiredSpan}</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Enter Title..."
                                value={title}
                                onChange={(e) => actions.setValue({ title: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Description {requiredSpan}</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                placeholder="Enter Description..."
                                value={descriptions}
                                onChange={(e) => actions.setValue({ descriptions: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col md={5}>
                                    <ControlLabel>Earning Period {requiredSpan}</ControlLabel>
                                </Col>
                                <Col md={7}>
                                    <Select.Async
                                        placeholder="Select or Search..."
                                        loadOptions={(input, cb) => loadOptions(input, cb, "VoucherEarningPeriod", "name")}
                                        value={earningPeriod}
                                        onChange={(value) => {
                                            let stateToUpdate = {
                                                earningPeriod: value
                                            };

                                            if (
                                                value &&
                                                value.label &&
                                                value.label.toUpperCase() === "DATE RANGE" &&
                                                (
                                                    earningPeriodStartDate !== "" ||
                                                    earningPeriodEndDate !== ""
                                                )
                                            ) {
                                                stateToUpdate.earningPeriodStartDate = "";
                                                stateToUpdate.earningPeriodEndDate = "";
                                            } else if (
                                                earningPeriodStartDate !== "" ||
                                                earningPeriodEndDate !== ""
                                            ) {
                                                stateToUpdate.earningPeriodStartDate = "";
                                                stateToUpdate.earningPeriodEndDate = "";
                                            }

                                            actions.setValue(stateToUpdate);
                                        }}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        {
                            IS_VALID(earningPeriod) &&
                            earningPeriod.label.toUpperCase() === "DATE RANGE" ? (
                                <FormGroup>
                                    <InputGroup>
                                        <DateTime
                                            dateFormat="MMM DD, YYYY"
                                            timeFormat={false}
                                            value={earningPeriodStartDate}
                                            onChange={(datetime) => {
                                                actions.setValue({ earningPeriodStartDate: datetime });
                                            }}
                                            inputProps={{
                                                placeholder: "Earning Start Date",
                                                style: {
                                                    position: "initial",
                                                    borderRadius: "4px 0 0 4px"
                                                }
                                            }}
                                        />
                                        <InputGroup.Addon>TO</InputGroup.Addon>
                                        <DateTime
                                            dateFormat="MMM DD, YYYY"
                                            timeFormat={false}
                                            value={earningPeriodEndDate}
                                            onChange={(datetime) => {
                                                actions.setValue({ earningPeriodEndDate: datetime });
                                            }}
                                            inputProps={{
                                                placeholder: "Earning End Date",
                                                style: {
                                                    position: "initial",
                                                    borderRadius: "0 4px 4px 0"
                                                }
                                            }}
                                        />
                                    </InputGroup>
                                </FormGroup>
                            ) : (
                                ""
                            )
                        }
                        {IS_VALID(earningPeriod) &&
                        earningPeriod.label.toUpperCase() === "DAILY" &&
                        <FormGroup>
                            <ControlLabel>Availability Time</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat={false}
                                    timeFormat="hh:mm A"
                                    value={availabilityStartTime}
                                    onChange={(datetime) => {
                                        actions.setValue({ availabilityStartTime: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "Availability Start Time",
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat={false}
                                    timeFormat="hh:mm A"
                                    value={availabilityEndTime}
                                    onChange={(datetime) => {
                                        actions.setValue({ availabilityEndTime: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "Availability End Time",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>
                        }
                        <FormGroup>
                            <ControlLabel>Campaign Date{totalCampaignDays >= 0 ? ` (${totalCampaignDays} day${totalCampaignDays > 1 ? "s" : ""}) ` : " "}{requiredSpan}</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat="hh:mm A"
                                    value={campaignStartDate}
                                    onChange={(datetime) => {
                                        if (!isEVoucherPublished) {
                                            actions.setValue({ campaignStartDate: datetime });
                                        }
                                    }}
                                    inputProps={{
                                        placeholder: "Start Date",
                                        disabled: isEVoucherPublished,
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat="hh:mm A"
                                    value={campaignEndDate}
                                    onChange={(datetime) => {
                                        actions.setValue({ campaignEndDate: datetime });
                                    }}
                                    inputProps={{
                                        placeholder: "End Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>EVoucher Sorting</ControlLabel>
                            <Row>
                                <Col md={6}>
                                    <Select
                                        {...{
                                            clearable: false,
                                            value: evoucherSortColumn,
                                            onChange: (value) => {
                                                actions.setValue({
                                                    evoucherSortColumn: value
                                                });
                                            },
                                            options: evoucherSortColumnOptions
                                        }}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Select
                                        {...{
                                            clearable: false,
                                            value: evoucherSorting,
                                            onChange: (value) => {
                                                actions.setValue({
                                                    evoucherSorting: value
                                                });
                                            },
                                            options: evoucherSortingOptions
                                        }}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup style={{ position: 'relative' }}>
                            <ControlLabel>Image</ControlLabel>
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '30px',
                                    height: '30px',
                                    background: 'red',
                                    paddingTop: '4px',
                                    top: '15px',
                                    right: '-9px',
                                    zIndex: 5,
                                    textAlign: 'center',
                                    borderRadius: '50px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    ...isHideX
                                }}
                                onClick={() => {
                                    actions.setValue({ image: null });
                                }}
                            >
                                x
                            </div>
                            <Dropzone
                                style={{
                                    position: "",
                                    width: "100%",
                                    height: "300px",
                                    border: "1px solid #e1e1e1",
                                    borderRadius: "0px",
                                    backgroundColor: "#f5f5f5",
                                    ...dropZoneStyle
                                }}
                                accept="image/*"
                                multiple={false}
                                onDropAccepted={(acceptedArray) => {
                                    actions.setValue({ image: acceptedArray[0] });
                                }}
                            >
                                <img
                                style={imageStyle}
                                src={imageSrc}
                                />
                            </Dropzone>
                        </FormGroup>
                        <FormGroup style={{ position: 'relative' }}>
                            <ControlLabel>Banner Image</ControlLabel>
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '30px',
                                    height: '30px',
                                    background: 'red',
                                    paddingTop: '4px',
                                    top: '15px',
                                    right: '-9px',
                                    zIndex: 5,
                                    textAlign: 'center',
                                    borderRadius: '50px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    ...banner_isHideX
                                }}
                                onClick={() => {
                                    actions.setValue({ bannerImage: null });
                                }}
                            >
                                x
                            </div>
                            <Dropzone
                                style={{
                                    position: "",
                                    width: "100%",
                                    height: "150px",
                                    border: "1px solid #e1e1e1",
                                    borderRadius: "0px",
                                    backgroundColor: "#f5f5f5",
                                    ...banner_dropZoneStyle
                                }}
                                accept="image/*"
                                multiple={false}
                                onDropAccepted={(acceptedArray) => {
                                    actions.setValue({ bannerImage: acceptedArray[0] });
                                }}
                            >
                                <img
                                style={banner_imageStyle}
                                src={banner_imageSrc}
                                />
                            </Dropzone>
                        </FormGroup>
                    </Col>
                </Row>
            </form>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  CAMPAIGN_CATEGORY
}                           from "actions/const";

function mapStateToProps(state) {
	let {
        CampaignCategory
	} = state;

    let {
        isLoadingAction,

        selectedData,

        image,
        bannerImage,
        title,
        descriptions,
        earningPeriod,
        earningPeriodStartDate,
        earningPeriodEndDate,
        campaignStartDate,
        campaignEndDate,
        evoucherSortColumn,
        evoucherSortColumnOptions,
        evoucherSorting,
        evoucherSortingOptions,

        availabilityStartTime,
        availabilityEndTime
    } = CampaignCategory;

	return {
        isLoadingAction,

        selectedData,

        image,
        bannerImage,
        title,
        descriptions,
        earningPeriodStartDate,
        earningPeriodEndDate,
        earningPeriod,
        campaignStartDate,
        campaignEndDate,
        evoucherSortColumn,
        evoucherSortColumnOptions,
        evoucherSorting,
        evoucherSortingOptions,

        availabilityStartTime,
        availabilityEndTime
	};
}

function mapDispatchToProps(dispatch) {
    const actions = {
        setValue: (state, action = CAMPAIGN_CATEGORY) => generics.setValue(action, state)
    };
  
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Create);


// WEBPACK FOOTER //
// ./components/CampaignCategory/FormContainer/Create.js